import { type Enum } from '@webapp/infrastructure/types/Enum'

// Selects the report base path /api/v3/reports/orders/{dimension}.
export const OrderReportDimensions = {
  VENDORS: 'vendors',
  USERS: 'users',
  SECONDARY_CATEGORIES: 'departments',
} as const

export type OrderReportDimension = Enum<typeof OrderReportDimensions>
